/**
 * Open a URL outside the task pane.
 *
 * Inside Office the pane's webview may refuse `window.open`; the Office API
 * hands the URL to the system browser instead. Outside Office (the pane in a
 * browser tab during development) a normal new tab is fine.
 * @param url - The absolute URL to open.
 */
export const openExternal = (url: string): void => {
  try {
    const ui = Office?.context?.ui as { openBrowserWindow?: (url: string) => void } | undefined;
    if (ui?.openBrowserWindow && Office.context.requirements.isSetSupported("OpenBrowserWindowApi", "1.1")) {
      ui.openBrowserWindow(url);
      return;
    }
  } catch {
    // fall through to window.open
  }
  window.open(url, "_blank", "noopener,noreferrer");
};

const WEB_APP_URL = (process.env.REACT_APP_WEB_APP_URL || "https://app.mytender.io").replace(/\/+$/, "");

/**
 * The web app page for a bid view.
 * @param bidId - The bid; null opens the bids list.
 * @param view - The web app's tab id (e.g. "proposal-planner"), or null for the default.
 * @returns The absolute URL.
 */
export const mytenderUrl = (bidId: string | null, view: string | null = null): string => {
  if (!bidId) return `${WEB_APP_URL}/bids`;
  const params = new URLSearchParams({ id: bidId });
  if (view) params.set("tab", view);
  return `${WEB_APP_URL}/bid?${params.toString()}`;
};
